import { CertificateService } from '../../services/certificate.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of, share, switchMap } from 'rxjs';
import { CertificateActions } from '@states/certificate/certificate.action-types';
import { Injectable } from '@angular/core';
import { withLatestFrom } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import * as SharedActions from '@states/shared/shared.actions';
import { AppState } from '../app.state';
import { UtilsService } from '../../edge/utils.service';

@Injectable()
export class CertificateEffects {
  public beforeGetSupportOrgLogs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificateActions.beforeGetCertificates),
      switchMap(({ filters }) => [
        CertificateActions.setCertificatesLoader({ loading: true }),
        CertificateActions.getCertificates({ filters }),
      ]),
      share(),
    ),
  );

  public getSupportOrgLogs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CertificateActions.getCertificates),
      withLatestFrom(this.store$.pipe(select((state) => state.certificateState))),
      switchMap(([{ filters }, { limit, page , isLastPage}]) => {
        if (!isLastPage) {
          return this.certificateService.getByFilters(filters, page, limit).pipe(
            mergeMap((response) => {
              return [
                CertificateActions.getCertificatesSuccess({
                  documents: response.results,
                  page: response.page,
                  limit: response.limit,
                }),
              ];
            }),
            catchError((response) => {
              const message = this.utilsService.errMessage(response);
              return [
                CertificateActions.getCertificatesLogsFail(),
                SharedActions.consoleMessage({ error: message }),
              ];
            }),
          );
        } else {
          return of(SharedActions.doNothing());
        }
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private certificateService: CertificateService,
    private store$: Store<AppState>,
    private utilsService: UtilsService,
  ) {}
}
